package one.healthium.tasks.ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.red_2
import one.healthium.ui.compose.theme.white
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun DailyTasksBadge(
    modifier: Modifier = Modifier,
    borderStroke: BorderStroke? = null,
) {
    val viewModel = koinViewModel<DailyTasksViewModel>()
    val state by viewModel.state.collectAsState()

    DailyTasksBadgeContent(
        modifier = modifier,
        borderStroke = borderStroke,
        state = state,
    )
}

@Composable
private fun DailyTasksBadgeContent(
    modifier: Modifier = Modifier,
    borderStroke: BorderStroke? = null,
    state: DailyTasksUiState,
) {
    AnimatedVisibility(
        modifier = modifier,
        visible = state.hasUnread,
        enter = fadeIn(),
        exit = fadeOut(),
    ) {
        Box(
            Modifier
                .size(9.dp)
                .then(
                    if (borderStroke != null) {
                        Modifier.border(borderStroke, shape = CircleShape)
                    } else {
                        Modifier
                    }
                )
                .background(color = red_2, shape = CircleShape)
        )
    }
}

@Composable
@Preview(showBackground = true)
private fun DailyTasksBadgeContentPreview() {
    AppTheme {
        DailyTasksBadgeContent(
            borderStroke = BorderStroke(width = 1.dp, color = white),
            state = DailyTasksUiState(hasUnread = true),
        )
    }
}